import { render } from "./InfiniteScroll.vue?vue&type=template&id=52ab051e"
import script from "./InfiniteScroll.vue?vue&type=script&lang=ts"
export * from "./InfiniteScroll.vue?vue&type=script&lang=ts"
script.render = render

export default script